import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';
import { QuickChatWelcome } from './QuickChatWelcome';
import { QuickChatThreads } from './QuickChatThreads';
import { useQuickChat } from '@/hooks/home/useQuickChat';
import DashboardHeader from '@/components/dashboard/DashboardHeader';

export const QuickChatSection: React.FC = () => {
  const {
    hasThreads,
    threads,
    isLoadingThreads,
    isSendingMessage,
    handleSendMessage,
    handleOpenThread,
    handleViewAllThreads
  } = useQuickChat();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="h-full"
    >
             {/* Card with same styling as Quick Actions */}
       <div className="h-full bg-gradient-to-br from-white/80 via-white/90 to-white/80 dark:from-slate-800/80 dark:via-slate-800/90 dark:to-slate-900/80 backdrop-blur-md border border-white/20 dark:border-white/5 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
         {/* Subtle gradient background */}
         <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-purple-50/20 to-blue-50/30 dark:from-blue-900/10 dark:via-purple-900/5 dark:to-blue-900/10 rounded-xl" />
        
        {/* Content */}
        <div className="relative z-10 p-6 h-full flex flex-col">
          {/* Header */}
          <div>
            <DashboardHeader
              title="AI Agents"
              icon={<MessageSquare size={20} />}
              hideOnMobile={false}
            />
          </div>
          
          {/* Dynamic Content */}
          <div className="flex-1 min-h-0">
            {!hasThreads ? (
              <QuickChatWelcome
                onSendMessage={handleSendMessage}
                isLoading={isSendingMessage}
              />
            ) : (
              <QuickChatThreads
                threads={threads}
                isLoading={isLoadingThreads}
                onThreadClick={handleOpenThread}
                onSendMessage={handleSendMessage}
                onViewAllThreads={handleViewAllThreads}
                isSendingMessage={isSendingMessage}
              />
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}; 